import $ from 'jquery';
import blocks from 'lib/analytics/blocks/index';
import anComponentView from 'lib/analytics/componentView';
import anClicks from 'lib/analytics/click';
import anAddContext from 'lib/analytics/context.add';

var dealerSeo = {
  load: function (el, config) {
    this.$scope = $(el);
    this.page = config.page;
    this.analytics();
  },

  analytics: function () {
    var $scope = this.$scope;
    anAddContext($scope, blocks.sectionBlock(this.page));
    anClicks($scope);
    anComponentView($scope);
  },
};

export default dealerSeo;
